import React, { useState } from "react";
import { Segmented, DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const LogsDateFilter = ({ onChange, disabled = false }) => {
    const [preset, setPreset] = useState("today");
    const [range, setRange] = useState(null);

    const OPTIONS = [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "Last Week", value: "lastWeek" },
    ];

    const disabledDate = (current) => {
        if (!current) return false;

        const today = dayjs().endOf("day");
        const sevenDaysAgo = dayjs().subtract(7, "day").startOf("day");

        return current > today || current < sevenDaysAgo;
    };

    const emit = (from, to) => {
        onChange?.({
            from: from.format("YYYY-MM-DD"),
            to: to.format("YYYY-MM-DD"),
        });
    };

    const handlePresetChange = (value) => {
        setPreset(value);
        setRange(null);

        let from, to;

        if (value === "today") {
            from = dayjs().startOf("day");
            to = dayjs().endOf("day");
        }

        if (value === "yesterday") {
            from = dayjs().subtract(1, "day").startOf("day");
            to = dayjs().subtract(1, "day").endOf("day");
        }

        if (value === "lastWeek") {
            from = dayjs().subtract(7, "day").startOf("day");
            to = dayjs().endOf("day");
        }

        emit(from, to);
    };

    const handleRangeChange = (dates) => {
        setPreset(null);
        setRange(dates);

        if (!dates) return;

        emit(dates[0], dates[1]);
    };

    const styledCss = `
/* ===== FORCE ROBOTO ===== */
.logs-range-controls,
.logs-range-controls * {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
}

/* ===== SEGMENTED ===== */
.logs-range-controls .ant-segmented {
  padding: 0;
  border-radius: 999px;
  border: 1px solid #ef4444;
  background: #ffffff;
  overflow: hidden;
  height: 36px;
}

.logs-range-controls .ant-segmented-item::after {
  display: none !important;
}

.logs-range-controls .ant-segmented-item {
  padding: 0 !important;
  margin: 0;
  background: transparent !important;
}

.logs-range-controls .ant-segmented-item-label {
  height: 36px;
  line-height: 36px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 500;
  color: #000;
  background: #ffffff;
  border-right: 1px solid #ef4444;
  transition: all 0.2s ease;
}

.logs-range-controls
.ant-segmented-item:last-child
.ant-segmented-item-label {
  border-right: none;
}

.logs-range-controls .ant-segmented-item-label:hover {
  background: #fff1f2;
}

.logs-range-controls .ant-segmented-item-selected {
  background: transparent !important;
}

.logs-range-controls
.ant-segmented-item-selected
.ant-segmented-item-label {
  background: #ef4444;
  color: #ffffff;
  font-weight: 600;
}

/* ===== RANGE PICKER ===== */
.logs-range-controls .ant-picker {
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 13px;
}

.logs-range-controls .ant-picker-input {
  height: 36px;
  display: flex;
  align-items: center;
}

.logs-range-controls .ant-picker-input > input {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
}
`;

    return (
        <div
            className="logs-range-controls"
            style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
            }}
        >
            <style>{styledCss}</style>

            <Segmented
                options={OPTIONS}
                value={preset}
                onChange={handlePresetChange}
                disabled={disabled}
            />

            <RangePicker
                value={range}
                onChange={handleRangeChange}
                disabledDate={disabledDate}
                allowClear
                disabled={disabled}
            />

            {disabled && (
                <span
                    style={{
                        fontSize: 12,
                        color: "#ef4444",
                        marginLeft: 4,
                        fontWeight: 500,
                    }}
                >
                    Select a charger first
                </span>
            )}
        </div>
    );
};

export default LogsDateFilter;
